/**
 *  Vuex Rest API
 *
 *  @model Device
 */
import Vapi from 'vuex-rest-api'
import apiConfig from '@/config/api'
import { getPaginated } from '@/helpers/general'
import { axiosInstance } from '../../plugins/axios'

import { state } from './Payments/state'
import { mutations } from './Payments/mutations'

/**
 *  Users on REST API
 */
const api = new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state: {
    payment: {},
    subscription: {},
    subscriptions: [],
    ...state
  }
}).get({
  action: 'getSubscription',
  property: 'subscription',
  path: ({ id }) => `/subscriptions/${id}`
}).get({
  action: 'getSubscriptions',
  property: 'subscriptions',
  path: (params) => getPaginated(params, 'subscriptions')
}).get({
  action: 'getPayments',
  property: 'payments',
  path: (params) => getPaginated(params, 'payments')
}).get({
  action: 'getPayment',
  property: 'payment',
  path: ({ id }) => `/subscriptions/${id}`
}).post({
  action: 'createSubscription',
  property: 'subscriptions',
  path: '/subscriptions'
}).post({
  action: 'attachVendorSubscription',
  property: 'subscription',
  path: '/vendors/attach-subscription'
}).post({
  action: 'detachVendorSubscription',
  property: 'subscription',
  path: '/vendors/detach-subscription'
}).post({
  action: 'attachDepartmentSubscription',
  property: 'subscription',
  path: '/departments/attach-subscription'
}).post({
  action: 'detachDepartmentSubscription',
  property: 'subscription',
  path: '/departments/detach-subscription'
}).post({
  action: 'attachEnterpriseSubscription',
  property: 'subscription',
  path: '/enterprises/attach-subscription'
}).post({
  action: 'detachEnterpriseSubscription',
  property: 'subscription',
  path: '/enterprises/detach-subscription'
}).post({
  action: 'attachCompanySubscription',
  property: 'subscription',
  path: '/companies/attach-subscription'
}).post({
  action: 'detachCompanySubscription',
  property: 'subscription',
  path: '/companies/detach-subscription'
}).put({
  action: 'updateSubscription',
  property: 'subscription',
  path: ({ id }) => `/subscriptions/${id}`
}).delete({
  action: 'deleteSubscription',
  property: 'subscription',
  path: ({ id }) => `/subscriptions/${id}`
})

const Payments = api.getStore({
  namespaced: true,
  createStateFn: true
})

Payments.mutations = {
  ...Payments.mutations,
  ...mutations
}

export default Payments
